export const getNameDataSetByElements = (
  elements: Array<HTMLElement>,
): Array<string> =>
  elements.reduce<Array<string>>((acc, element) => {
    if (element.dataset.name) {
      return [...acc, element.dataset.name];
    }

    return acc;
  }, []);
